import * as React from 'react';
import OrdersLayout from "../components/OrdersLayout"
 
const InProgressOrders: React.SFC = () => {
    return (  
        <OrdersLayout/>
    );
}
 
export default InProgressOrders;